import {
  Form,
  Row,
  Col,
  Input,
  Select,
  Button,
  Checkbox,
  Popconfirm,
  notification,
  Popover,
  Modal,
} from 'antd'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import styles from './newCommodity.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { NavBar } from '../../compnents/nav/NavBar'
import { getCommodityDetail, getShopGoodsNo, getSyncInventoryAsync, getZjWbCodes, logoutOrenableCommodity, selectCommodityDetail, selectCommodityId, selectShopNo, setCommodityDetail, setCurrent, setSelectId, saveCommodityAsync } from '../commodity/commoditySlice'
import { selectInsuranceArray, selectTenantCategory } from '../../app/applicationSlice'
import { useHistory, useLocation } from 'react-router-dom'
import { RecipeItemInput } from '../commodity/componment/RecipeItemInput'
import { getCommonCodeCompletions, ItemCompletionType, selectCommonCodes } from '../completion/completionSlice'
import { CaretDownFilled, CaretUpFilled, CheckCircleOutlined, ExclamationCircleFilled, } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import { RootDispatch } from '../../app/store'
import { DrugCategories, getChrgitmLvName, getDrugCategoryName, getMaterialsName, Materiales, } from '../../models/commodity'
import { CommonCodeCategory } from '../../models/commoncode'
import { BillingCategoryName, InvoiceBillingCategories } from '../../models/billingCategory'
import { RecipeItemFieldInput } from '../treatment/editor/components/RecipeItemFieldInput'
import QuestionTipsImg from '../../compnents/icons/png/questionTips.png'
import { SupplierModal } from '../savebusiness/modal'
import { SupplierModal as SupplierSaveModal } from '../wms/modal'
import { Checks } from '../../models/setting'
import { selectSettings } from '../user/setting/settingSlice'
import ElseImg from './image/else.png'

const { Option } = Select
const { TextArea } = Input
const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 22 },
}

const firstColumnLayout = {
  labelCol: {
    flex: '0 0 6rem',
  },
}

const titleColumnLayout = {
  labelCol: {
    flex: '0 0 9rem',
  },
}

export const NewNondurgSaveform = (props: {
  billingCategory?: any
  hilistCode?: any
  mappingId?: any
  flag?: any
  materialCategory?: any //类别
  details?: any //码上放心过来的
  refresh?: (v?: any) => void
}): ReactElement => {

  const [form] = Form.useForm()

  const history = useHistory()

  const location: any = useLocation()

  const minPackNumsRef = useRef<any>(null) //最小包装数量输入框

  const minPackUnitRef = useRef<any>(null) //最小包装单位输入框

  const accountUnitRef = useRef<any>(null) //账簿单位输入框

  const dispatch = useDispatch<RootDispatch>()

  // props?.materialCategory 一般是码上放心弹窗过来的
  const materialCategory = location?.state?.materialCategory?.toString() ? location?.state?.materialCategory : props?.materialCategory

  const settings = useSelector(selectSettings)

  const shopNo = useSelector(selectShopNo)

  const selectId = useSelector(selectCommodityId)

  const detail: any = useSelector(selectCommodityDetail)

  const insuranceArray = useSelector(selectInsuranceArray)

  const tenantCategory = useSelector(selectTenantCategory)  // 17 校医务室 不展示进价售价

  const [tenantSupplierId, setTenantSupplierId] = useState(0)

  const DWdata = useSelector(selectCommonCodes(CommonCodeCategory.Unit)) //账簿单位

  const [source, setSource] = useState(0)

  const [open, setOpen] = useState(false)

  const [writeBack, setWriteBack] = useState(false)

  const [isSubmitLoading, setIsSubmitLoading] = useState<any>(false) //提交loading

  const [saveAndContinue, setSaveAndContinue] = useState<any>(false) //是否保存并继续

  const [sourceMaterialsCatalogId, setSourceMaterialsCatalogId] = useState()

  const [isModalVisible, setIsModalVisible] = useState(false) //生产厂家供应商弹窗选择

  const [isAddModalVisible, setIsAddModalVisible] = useState(false) //是否添加生产厂家

  const [loading, setLoading] = useState(false) //同步售价到库存弹窗loading

  const [isChecked, setIsChecked] = useState<any>(false) //是否生成调价记录

  const [sureVisible, setSureVisible] = useState(false) //同步售价到库存弹窗

  const [extendInformation, setExtendInformation] = useState<any>() //扩展信息箭头

  const [memberDiscountType, setMemberDiscountType] = useState(0) // 会员价折扣类型：0折扣 1特价

  const [cachedSpecialPrice, setCachedSpecialPrice] = useState<any>(null)

  const [cachedDiscountPrice, setCachedDiscountPrice] = useState<any>(null)

  useEffect(() => {
    if (!localStorage.getItem('time2')) {
      localStorage.setItem('time2', JSON.stringify(new Date()))
      setOpen(true)
    } else {
      setOpen(false)
    }
  }, [])

  useEffect(() => {
    if (sureVisible) {
      const SFSCBDJLHTJJL = localStorage?.getItem('SFSCBDJLHTJJL')
      setIsChecked(SFSCBDJLHTJJL == 'true' ? true : false)
    }
  }, [sureVisible])

  // 类别回填
  useEffect(() => {
    form.setFieldsValue({
      materialsCategory: materialCategory,
    })
  }, [materialCategory])

  // 初次默认进来清数据
  useEffect(() => {
    return () => {
      resetForm()
    }
  }, [])

  const resetForm = () => {
    form.resetFields()
    setComponentItem(undefined)
    dispatch(setSelectId(0))
    dispatch(setCommodityDetail({}))
    setExtendInformation(false)
  }

  // 回填数据
  useEffect(() => {
    if (JSON.stringify(detail) !== '{}') {
      setFileds(detail, true)
    } else if (props?.details && JSON.stringify(props?.details) !== '{}') {
      setFileds(props?.details, false)
    } else {
      const drugCategory = form.getFieldValue('drugCategory') || '其他产品'
      // 新增默认值
      form.setFieldsValue({
        noTraceCodeFlag: '0', //药品标识码  (有码)
        drugCategory: drugCategory, //药品分类 (有选中的就是选中的 没有就是第一个)
        billingCategory: '99', //开票项目
      })
    }
  }, [detail, props?.details])

  // 编辑回填
  const setFileds = (detail?: any, flag?: boolean) => {
    const memberInterestVO = detail?.memberInterestVO || {}
    form.setFieldsValue({
      ...detail,
      ...detail?.mixInsuranceCatalog,
      ...detail?.materialsCatalogPlus,
      retailPrice: flag ? (detail?.retailPrice == -1 ? '' : detail?.retailPrice) : '',
      tax: detail?.tax == -1 ? '' : detail?.tax,
      spec: detail?.spec,
      hiListSpec: detail?.mixInsuranceCatalog?.spec,
      chrgitmLv: getChrgitmLvName(detail?.mixInsuranceCatalog?.chrgitmLv),
      otc: detail?.otc !== 10 ? detail?.otc : undefined,
      minPackNums: detail?.materialsCatalogPlus?.minPackNums > 0 ? detail?.materialsCatalogPlus?.minPackNums : '', //最小包装数量
      minPackUnit: detail?.materialsCatalogPlus?.minPackUnit || '', //最小包装单位

      stimulantTag: detail?.stimulantTag > 0 ? true : false,
      ephedrineTag: detail?.ephedrineTag > 0 ? true : false,
      antibioticTag: detail?.antibioticTag > 0 ? true : false,
      basicMedicineTag: detail?.basicMedicineTag > 0 ? true : false,
      skinTestTag: detail?.skinTestTag > 0 ? true : false,
      qualityControlCategory:
        detail?.qualityControlCategory < 0
          ? undefined
          : detail?.qualityControlCategory,
      splitPrice: detail?.splitPrice < 0 ? undefined : detail?.splitPrice,
      splitScale: detail?.splitScale < 0 ? undefined : detail?.splitScale,
      putCategory: detail?.putCategory < 0 ? undefined : detail?.putCategory,
      stockPrice: detail?.stockPrice < 0 ? undefined : detail?.stockPrice,
      drugCategory: getDrugCategoryName(detail?.drugCategory)
        ? getDrugCategoryName(detail?.drugCategory)
        : '',
      maintainCategory:
        detail?.maintainCategory > 0 ? detail?.maintainCategory : 0,
      memberPrice: memberInterestVO?.price === -1
        ? undefined
        : memberInterestVO?.discountType === 1 && memberInterestVO?.price != null
          ? Number(memberInterestVO.price).toFixed(5)
          : memberInterestVO?.price,
    })
    setMemberDiscountType(memberInterestVO?.discountType === -1 ? 0 : (memberInterestVO?.discountType ?? 0))
    if (memberInterestVO?.discountType === 1 && memberInterestVO?.price != null && memberInterestVO?.price !== -1) {
      setCachedSpecialPrice(Number(memberInterestVO.price).toFixed(5))
    }
    if (props?.flag == '/msfxFlag') {
      getZjWbCodesAsync(detail?.name)
    }
    setTenantSupplierId(detail?.tenantSupplierId)
  }

  // 下拉回填
  const recipeItemInputSetFileds = (m?: any) => {
    form.setFieldsValue({
      ...m,
      tax: m?.tax == -1 ? '' : m?.tax,
      source: 1,
      allStr: m.name,
      billingCategory: m.billingCategory.toString(),
      stockPrice: null, //进价/元
      retailPrice: '', //售价/元
    })
  }

  // 获取药品编码
  useEffect(() => {
    if (!selectId) {
      dispatch(getShopGoodsNo())
    }
  }, [selectId])

  // 回填药品编码
  useEffect(() => {
    if (shopNo) {
      form.setFieldsValue({
        no: shopNo,
      })
    }
  }, [shopNo])

  const [componentItem, setComponentItem] = useState<any>({
    name: '',
    billingCategory: '',
    tenantSupplierName: '',
    approvalNumber: '',
  })

  useEffect(() => {
    dispatch(getCommonCodeCompletions(CommonCodeCategory.Unit, ''))
  }, [])

  useEffect(() => {
    if (selectId) {
      dispatch(getCommodityDetail({ id: selectId }))
    }
  }, [selectId])

  // 物资名称输入获取
  const getWubi = (e: any) => {
    getZjWbCodesAsync(e)
    setComponentItem({
      ...componentItem,
      name: e,
    })
  }

  const recordSetFiles = (item: any) => {
    form.setFieldsValue({
      proviceHilistCode: item?.proviceHilistCode, //医保省市编码
      hiListCode: item.hiListCode, //医保国码
      hilistName: item.hilistName + getChrgitmLvName(item.chrgitmLv), //医保名称 + 甲乙分类
      approvalNumber: item.aprvno, //批准文号
      limitCount: item.limitCount, //医保限量开方

      //顺便回写基础目录信息
      name: writeBack ? item.hilistName : form.getFieldValue('name'),
      genericName: item.hilistName, //商品名
      mnemonicCode: item?.mnemonicCode, //助记码
      wubiCode: item?.wubiCode, //五笔码
      doseCategory:
        item.dosformName || form.getFieldValue('doseCategory'), //剂型
      accountUnit: item.pacunt || form.getFieldValue('accountUnit'),//包装单位
      tenantSupplierName:
        item.prodentpName || form.getFieldValue('tenantSupplierName'), //生产厂家
      // spec: item.spec || form.getFieldValue('spec'),
      otc:
        item.otcFlag === '0' || item.otcFlag === '1'
          ? parseInt(item.otcFlag)
          : form.getFieldValue('otc'), //是否OTC
    })
  }

  // 五笔码回填
  const getZjWbCodesAsync = (item: any) => {
    dispatch(getZjWbCodes(item))
      .then(unwrapResult)
      .then((v: any) => {
        form.setFieldsValue({
          mnemonicCode: v?.pinYin,
          wubiCode: v?.wuBi,
        })
      })
  }

  // 注销或启用
  const setStateStatus = (id: any, status: boolean) => {
    const params = status ? {
      id: id, forceRemove: 1
    } : {
      id: id
    }
    dispatch(logoutOrenableCommodity(params))
      .then(unwrapResult)
      .then(() => {
        notification.success({ message: '操作成功' })
        history.push({
          pathname: '/storage/station',
          state: {
            station: '5',
          },
        })
      })
  }

  // 取消
  const returnMessage = () => {
    dispatch(setSelectId(0))
    dispatch(setCommodityDetail({}))
    if (props?.flag == '/msfxFlag') {
      props?.refresh && props?.refresh()
    } else {
      history.push({
        pathname: '/storage/station',
        state: {
          station: '5',
        },
      })
    }
  }

  return (
    <>
      {props?.materialCategory?.toString() ? (
        <></>
      ) : (
        <Col
          style={{
            margin: '10px 20px',
          }}
        >
          <NavBar
            where={[
              '商品目录',
              JSON.stringify(detail) !== '{}' ? getMaterialsName(materialCategory) + '修改' : getMaterialsName(materialCategory) + '新增',
            ]}
            backtrace={{
              name: '库房工作站',
              path: '/storage/station',
              state: {
                station: '5',
              },
              routeName: '库房工作站',
            }}
            buttons={<></>}
          />
        </Col>
      )}
      <div className={props?.flag == '/msfxFlag' ? styles.elseSaveform : styles.saveform}>
        <Form
          className={styles.formContent}
          {...layout}
          form={form}
          name='control-hooks'
          autoComplete='off'
          layout='vertical'
          onFinish={(vs) => {
            const commonParams = {
              source,
              tenantSupplierId,
              sourceMaterialsCatalogId,
              retailPrice: tenantCategory == 17 ? 0 : vs.retailPrice, //售价/元

              // 新增的2个字段
              minPackUnit: undefined, //最小包装单位
              minPackNums: undefined, //最小包装数量

              // 原有但现在页面不展示的字段
              compoundTag: 0,
              normalDose: 0,
              useDays: 0,
              normalUsemethod: 0,
              transitionScale: 0,
              genericName: '',
              normalFrequency: 0,
              doseCategory: 0,
              drugCategory: vs?.drugCategory || 0,
              otc: vs.otc || 0,
              splitTag: vs.splitTag ? 1 : 0,
              stimulantTag: vs.stimulantTag ? 1 : 0,
              ephedrineTag: vs.ephedrineTag ? 1 : 0,
              antibioticTag: vs.antibioticTag ? 1 : 0,
              basicMedicineTag: vs.basicMedicineTag ? 1 : 0,
              skinTestTag: vs.skinTestTag ? 1 : 0,
              splitScale: vs.splitScale ? vs.splitScale : 0,
              splitPrice: vs.splitPrice ? vs.splitPrice : 0,
              spec: vs.spec || '', //规格
            }

            const saveMappingBody = {
              billing_category: vs.billingCategory || '',
              hilist_code: vs.hiListCode || '',
              insuranceCode: insuranceArray[0]?.insuranceCode || '',
              is_reimbursement: '',
              limitId: '',
            }

            const materialsCatalogPlus = {
              minPackUnit: vs.minPackUnit, //最小包装单位
              minPackNums: vs.minPackNums, //最小包装数量
            }

            const memberInterestVO = tenantCategory == 1 ? {
              discountType: vs.discountType,
              price: vs.memberPrice,
            } : {}

            if (vs.minPackUnit == vs.accountUnit && vs.minPackNums != 1) {
              Modal.warning({
                centered: true,
                title: '提示',
                content: '格式错误，最小包装数量不为1时，包装单位和最小包装单位不能相同',
                okText: '知道了',
                icon: <ExclamationCircleFilled style={{ color: '#faad14' }} />,
              })
              return
            }

            const params = selectId
              ? {
                materialsCatalog: {
                  ...vs,
                  ...commonParams,
                  id: selectId,
                  memberInterestVO: memberInterestVO,
                },
                saveMappingBody: saveMappingBody,
                materialsCatalogPlus: materialsCatalogPlus,
              }
              : {
                materialsCatalog: {
                  ...vs,
                  ...commonParams,
                  memberInterestVO: memberInterestVO,
                },
                saveMappingBody: saveMappingBody,
                materialsCatalogPlus: materialsCatalogPlus,
              }

            setIsSubmitLoading(true)
            dispatch(saveCommodityAsync({ ...params }))
              .then(unwrapResult)
              .then((v?: any) => {
                dispatch(setSelectId(0))
                dispatch(setCommodityDetail({}))
                // 保存并继续
                if (saveAndContinue) {
                  const billingCategory = form.getFieldValue('billingCategory')
                  const drugCategory = form.getFieldValue('drugCategory')
                  resetForm()
                  // 获取药品编码
                  dispatch(getShopGoodsNo())
                  form.setFieldsValue({
                    billingCategory: billingCategory,
                    drugCategory: drugCategory,
                    materialsCategory: materialCategory,
                  })
                } else {
                  if (props?.flag == '/msfxFlag') {
                    props?.refresh && props?.refresh({ ...vs, ...commonParams, materialsCatalogId: v?.materialsCatalogId })
                  } else {
                    history.push({
                      pathname: '/storage/station',
                      state: {
                        station: '5',
                      },
                    })
                  }
                }
              })
              .finally(() => {
                setIsSubmitLoading(false)
              })
          }}
        >
          {/* 码上放心发货单展示信息 */}
          {props?.flag == '/msfxFlag' && JSON.stringify(props?.details) !== '{}' ?
            <Row style={{ position: 'relative', top: '0px', left: '0px', marginBottom: '4px' }}>
              <Col span={24} style={{ width: '100%', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                <span style={{ marginRight: '6px' }}>码上放心发货单</span>
                <span>商品名称：{props?.details?.name}，</span>
                <span>通用名：{props?.details?.genericName}，</span>
                <span>包装规格：{props?.details?.packSpec}，</span>
                <span>批准文号：{props?.details?.approvalNumber}，</span>
                {/* <span>转换比：{props?.details?.transitionScale}，</span> */}
                <span>生产厂家：{props?.details?.tenantSupplierName}</span>
              </Col>
            </Row>
            : ''
          }
          {/* 快捷创建商品 */}
          {JSON.stringify(detail) !== '{}' || selectId ?
            <></> :
            <Col span={15} style={{ display: 'flex' }}>
              <Col className={styles.creatShop}>快捷创建商品</Col>
              <Col
                span={21}
                style={{ display: 'flex', alignContent: 'center' }}
              >
                <Form.Item
                  {...titleColumnLayout}
                  name='allStr'
                  label=''
                  wrapperCol={{
                    span: 24,
                  }}
                  style={{ width: '100%' }}
                >
                  <RecipeItemInput
                    materialsCategory={materialCategory}
                    source={source}
                    type={ItemCompletionType.Auto}
                    filters={false}
                    defaultUsingSpecifiedBatch={false}
                    onSelect={(m: any) => {
                      setSource(0)
                      recipeItemInputSetFileds(m)
                      setSourceMaterialsCatalogId(m.id)
                      getZjWbCodesAsync(m.name)
                    }}
                  />
                </Form.Item>
                {JSON.stringify(props?.details) != '{}' ? <></> : open && (
                  <Popconfirm
                    title='扫条形码 (69码) 快速添加商品'
                    placement='right'
                    disabled
                    visible={open}
                    onConfirm={() => setOpen(false)}
                    showCancel={false}
                    icon={<CheckCircleOutlined />}
                    okText='我知道了'
                  >
                    <div style={{ marginTop: 15 }}></div>
                  </Popconfirm>
                )}
              </Col>
            </Col>}
          {/* 中心内容 */}
          <Row className={styles.centerContent}>
            {/* 左侧内容 */}
            <Col span={15} className={props?.flag == '/msfxFlag' ? styles.elseLeftContent : JSON.stringify(detail) !== '{}' ? styles.noSearchleftContent : styles.leftContent}>
              <div className={styles.titleText}>商品基本信息</div>
              <Row>
                <Col span={8}>
                  <Form.Item
                    name='no'
                    label='商品编码'
                    rules={[
                      { required: true },
                      {
                        pattern: new RegExp(/^[0-9a-zA-Z]{1,}$/, 'g'),
                        message: '请输入数字或字母',
                      },
                      {
                        max: 20,
                        message: '最长20位',
                      },
                    ]}
                  >
                    <Input
                      size='middle'
                      allowClear
                      disabled={selectId ? true : false}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='name'
                    label='物资名称'
                    rules={[{ required: true }, { max: 45, message: '最长45位!' }]}
                  >
                    <Input
                      size='middle'
                      autoFocus
                      allowClear
                      onInput={(e: any) => {
                        getWubi(e.target.value)
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label='类别'
                  >
                    <Row className={styles.hbCol}>
                      <Col span={9}>
                        <Form.Item name='materialsCategory' >
                          <Select placeholder='' allowClear disabled>
                            {Materiales.map((v) => (
                              <Option value={v} key={v}>
                                {getMaterialsName(v)}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={15}>
                        <Form.Item
                          name='drugCategory'
                        >
                          <Select allowClear={false}>
                            {DrugCategories.map((v: any) => (
                              <Option value={v} key={v}>
                                {getDrugCategoryName(v)}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='billingCategory'
                    label='开票项目'
                  >
                    <Select
                      placeholder='开票项目'
                      allowClear={false}
                    >
                      {InvoiceBillingCategories.map((v) => {
                        return (
                          <Option value={v} key={v}>
                            {BillingCategoryName(v)}
                          </Option>
                        )
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='approvalNumber'
                    label='批准文号'
                    rules={[{ max: 128, message: '最长128位!' }]}
                  >
                    <Input
                      size='middle'
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='model'
                    label='型号'
                    rules={[
                      { max: 128, message: '最长128位!' },
                    ]}>
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='tenantSupplierName'
                    label='生产厂家'
                  >
                    <Input
                      size='middle'
                      allowClear
                      onClick={() => {
                        setIsModalVisible(true)
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='barCode'
                    label='条形码'
                    rules={[{ max: 35, message: '最长35位!' }]}
                  >
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={8}>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='spec'
                    label='规格'
                    rules={[
                      { max: 128, message: '最长128位!' },
                    ]}
                  >
                    <Input size='middle' allowClear
                      onPressEnter={() => {
                        minPackNumsRef.current?.focus()
                      }} />
                  </Form.Item>
                </Col>
                <Col span={8} className={styles.hbCol} style={{ position: 'relative' }}>
                  <div className={styles.unitIcon}> * </div>
                  {/* 对应老的拆零比例+拆零单位 */}
                  <Form.Item
                    label='最小包装数量 ｜ 单位'
                    required={true}
                    rules={[
                      { required: true },
                    ]}
                  >
                    <Row>
                      <Col span={14}>
                        {/* 最小包装数量 */}
                        <Form.Item
                          name='minPackNums'
                          rules={[
                            {
                              required: true,
                              message: '请输入最小包装数量'
                            },
                            {
                              pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                              message: '请输入数字',
                            },
                          ]}
                        >
                          <Input
                            ref={minPackNumsRef}
                            size='middle'
                            allowClear
                            onChange={(e: any) => {
                              return
                            }}
                            onPressEnter={() => {
                              minPackUnitRef.current?.focus()
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={10}>
                        {/* 最小包装单位 */}
                        <Form.Item
                          name='minPackUnit'
                          rules={[
                            {
                              required: true,
                              message: '请选择单位',
                            },
                          ]}
                        >
                          <RecipeItemFieldInput
                            ref={minPackUnitRef}
                            placeholderInput='单位'
                            clearDataFlag={false}
                            field={'doseUnit'}
                            disabled={false}
                            noSize={true}
                            onPressEnter={() => {
                              accountUnitRef.current?.focus()
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Row style={{ position: 'relative' }}>
                    <div className={styles.unitIconCHU}> / </div>
                    <Col span={14}>
                      {/* 对应老的账簿单位 */}
                      <Form.Item
                        name='accountUnit'
                        label='包装单位'
                        rules={[{ required: true }]}
                      >
                        <RecipeItemFieldInput
                          ref={accountUnitRef}
                          field={'accountUnit'}
                          disabled={false}
                          noSize={true}
                        />
                      </Form.Item>
                    </Col>
                    <Popover
                      title='示例'
                      content={
                        <div>
                          <img
                            src={ElseImg}
                            style={{ width: '500px' }}
                            alt=''
                          />
                        </div>
                      }
                      placement='bottom'
                    >
                      <Col span={10} className={styles.bzdwTips}>查看示例</Col>
                    </Popover>
                  </Row>
                </Col>

              </Row>
              <div className={styles.titleTexts}>
                <span style={{ fontWeight: 'bold' }}>扩展信息</span>
                <span
                  className={styles.iconMain}
                  onClick={() => {
                    setExtendInformation(!extendInformation)
                  }}
                >
                  <span>{!extendInformation ? '展开' : '收起'}</span>
                  {!extendInformation ? (
                    <CaretDownFilled className={styles.icon} />
                  ) : (
                    <CaretUpFilled className={styles.icon} />
                  )}
                </span>
              </div>
              <Row style={{ display: extendInformation ? undefined : 'none' }}>

                <Col span={8} style={{ position: 'relative' }}>
                  <Form.Item
                    name='mnemonicCode'
                    label='助记码'
                    rules={[
                      {
                        max: 40,
                        message: '最长40位!',
                      },
                    ]}
                  >
                    <Input size='middle' allowClear
                    />
                  </Form.Item>
                  <Popover
                    content={
                      <div>
                        <p>
                          是指物资名称的拼音首字母，系统自动生成，设置后支持用助记码去搜索该商品。
                        </p>
                      </div>
                    }
                    placement='bottom'
                    title='说明'
                  >
                    <img src={QuestionTipsImg} className={styles.questionTips3} />
                  </Popover>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='wubiCode'
                    label='五笔码'
                    rules={[
                      {
                        max: 40,
                        message: '最长40位!',
                      },
                    ]}
                  >
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='origin'
                    label='产地'
                    rules={[
                      { max: 128, message: '最长128位!' },
                    ]}>
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ position: 'relative' }}>
                  {/* 第三方编号对应老的其他编号 */}
                  <Form.Item
                    name='miscNo'
                    label='第三方编号'
                    rules={[{ max: 40, message: '最长40位!' }]}
                  >
                    <Input
                      size='middle'
                      allowClear
                    />
                  </Form.Item>
                  <Popover
                    content={
                      <div>
                        <p>
                          主要用于购入入库导入库存时导入的商品和目录做关联。
                        </p>
                      </div>
                    }
                    placement='bottom'
                    title='说明'
                  >
                    <img src={QuestionTipsImg} className={styles.questionTips5} />
                  </Popover>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='tradeRemark'
                    label='注册商标'
                    rules={[{ max: 128, message: '最长128位!' }]}
                  >
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='productionLicence'
                    label='生产许可证'
                    rules={[{ max: 128, message: '最长128位!' }]}
                  >
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            { }
            {/* 校医务室药品不展示 */}
            {tenantCategory == 17 ? <></> : <>
              <Col span={9} className={props?.flag == '/msfxFlag' ? styles.elseRightContent : styles.rightContent}>
                <Row className={styles.rightContentTitle}>
                  <Col span={6} className={styles.titleText}>价格信息</Col>
                  <Col span={18} className={styles.titleButton}>
                    {/* 没有勾选零库存开单展示 */}
                    {detail?.id && !settings?.[Checks.Lkcky] ? (
                      <Button type="primary" size="middle" ghost
                        onClick={() => {
                          setSureVisible(true)
                        }}
                      >同步售价到库存</Button>
                    ) :
                      <></>}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} >
                    <Form.Item
                      name='retailPrice'
                      label='售价/元'
                      rules={[
                        { required: true },
                        {
                          pattern: new RegExp(/^\d+(\.\d{1,5})?$/, 'g'),
                          message: '请输入保留小数五位以内的数',
                        },
                      ]}
                    >
                      <Input size='middle' allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name='stockPrice'
                      label='进价/元'
                      rules={[
                        {
                          pattern: new RegExp(/^\d+(\.\d{1,5})?$/, 'g'),
                          message: '请输入保留小数五位以内的数',
                        },
                      ]}
                    >
                      <Input size='middle' allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12} style={{ position: 'relative' }}>
                    <Form.Item
                      name='tax'
                      label='项目税率'
                      rules={[
                        {
                          pattern: new RegExp(/^(0(\.\d{1,2})?|1(\.0{1,2})?)$/),
                          message: '请输入0~1之间的数字，支持小数点后两位',
                        },
                      ]}
                    >
                      <Input size='middle' />
                    </Form.Item>
                    <Popover
                      content={
                        <div>
                          <p>
                            如果您接入了电子发票，且需要控制每个项目的税率，可以在此处填写该项目的税率，如果您属于免税机构，则不需要填写。
                          </p>
                          <p>
                            如果您需要批量修改所有项目的税率，也可与我们的服务人员联系。
                          </p>
                          <p>格式为：0~1，保留2位小数点，如0.03</p>
                        </div>
                      }
                      placement='bottom'
                      title='说明'
                    >
                      <img src={QuestionTipsImg} className={styles.questionTips4} />
                    </Popover>
                  </Col>
                  {/* 1 药店 */}
                  {tenantCategory == 1 ?
                    <Col span={12}>
                      <Form.Item
                        {...firstColumnLayout}
                        label='会员价'
                      >
                        <Row className={styles.hbCol}>
                          <Col span={7}>
                            <Form.Item name='discountType' noStyle initialValue={0}>
                              <Select
                                onChange={(val) => {
                                  const memberPrice = form.getFieldValue('memberPrice')
                                  if (memberDiscountType === 0 && val === 1) {
                                    // 折扣 → 特价
                                    setCachedDiscountPrice(memberPrice)
                                    form.setFieldsValue({ memberPrice: cachedSpecialPrice ?? undefined })
                                  } else if (memberDiscountType === 1 && val === 0) {
                                    // 特价 → 折扣
                                    setCachedSpecialPrice(memberPrice)
                                    form.setFieldsValue({ memberPrice: cachedDiscountPrice ?? undefined })
                                  }
                                  setMemberDiscountType(val)
                                }}
                              >
                                <Select.Option value={0}>折扣</Select.Option>
                                <Select.Option value={1}>特价</Select.Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={17}>
                            <Form.Item
                              name='memberPrice'
                              noStyle
                              rules={[
                                memberDiscountType === 1
                                  ? {
                                    pattern: new RegExp(/^(0|[1-9]\d*)(\.\d{1,5})?$/),
                                    message: '请输入数字，支持小数点后五位',
                                  }
                                  : {
                                    pattern: new RegExp(/^(100|[1-9]?\d)$/),
                                    message: '折扣请输入0-100的整数',
                                  },
                              ]}
                            >
                              <Input
                                size='middle'
                                allowClear
                                addonAfter={memberDiscountType === 1 ? '元' : '%'}
                                onBlur={(e) => {
                                  if (memberDiscountType === 1 && e.target.value) {
                                    const num = Number(e.target.value)
                                    if (!isNaN(num)) {
                                      form.setFieldsValue({ memberPrice: num.toFixed(5) })
                                    }
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form.Item>
                    </Col> :
                    <></>
                  }
                </Row>
              </Col>
            </>}
          </Row>
        </Form>
        <div className={styles.bottomContent} style={{ position: 'relative' }}>
          {/* 编辑展示 */}
          {JSON.stringify(detail) != '{}' ? (
            <>
              {detail?.state == 1 ?
                <Popconfirm
                  title={'确认进行注销操作吗？'}
                  onConfirm={() => {
                    setStateStatus(detail.id, true)
                  }}
                  onCancel={() => {
                    setStateStatus(detail.id, false)
                  }}
                  okText='确认并同步删除套餐/未收费处方'
                  //取消按钮当做注销，确认按钮当做强行注销
                  cancelButtonProps={{
                    style: {
                      border: 0,
                      backgroundColor: '#027AFF',
                      color: '#FFF',
                    },
                  }}
                  okButtonProps={{
                    style: {
                      border: 0,
                      backgroundColor: '#fe2121',
                      color: '#FFF',
                    },
                  }}
                  cancelText='确认'
                >
                  <Button type="primary" ghost danger style={{ position: 'absolute', left: '20px' }}>注销</Button>
                </Popconfirm> :
                <Popconfirm
                  title={'确认进行启用操作？'}
                  onConfirm={() => {
                    setStateStatus(detail.id, false)
                  }}
                  onCancel={() => {
                    return
                  }}
                  okText='确认'
                  cancelText='取消'
                >
                  <Button type="primary" ghost style={{ position: 'absolute', left: '20px' }}>启用</Button>
                </Popconfirm>
              }
            </>
          ) : (
            <></>
          )}
          <Button
            style={{ marginRight: '10px' }}
            onClick={(() => {
              returnMessage()
            })}
          >
            取消
          </Button>
          <Button
            type="primary"
            loading={isSubmitLoading}
            style={{ marginRight: '10px' }}
            onClick={(() => {
              form.submit()
              setSaveAndContinue(false)
            })}>
            保存
          </Button>
          {/* 新增展示保存并继续 */}
          {JSON.stringify(detail) != '{}' || props?.flag == '/msfxFlag' || props?.flag == '/homeFlag' ? (
            <></>
          ) : <Button
            loading={isSubmitLoading}
            onClick={(() => {
              form.submit()
              setSaveAndContinue(true)
            })}>
            保存并继续
          </Button>}
        </div>
        {/* 生产厂家 supplierCategory=1  供应商 supplierCategory=0*/}
        <SupplierModal
          supplierCategory={1}
          visible={isModalVisible}
          switchModal={() => {
            setIsModalVisible(false)
            setIsAddModalVisible(true)
          }}
          onOk={() => {
            setIsModalVisible(false)
          }}
          onCancel={() => {
            setIsModalVisible(false)
          }}
          onRecord={(record: any) => {
            setTenantSupplierId(record.id)
            form.setFieldsValue({
              tenantSupplierName: record.companyName,
            })
          }}
        />
        {/* 新增供应商 */}
        <SupplierSaveModal
          visible={isAddModalVisible}
          supplierCategory={1}
          onOk={() => {
            setIsAddModalVisible(false)
            dispatch(setCurrent(1))
            dispatch(setSelectId(0))
            setIsModalVisible(true)
          }}
          onCancel={() => {
            setIsAddModalVisible(false)
            setIsModalVisible(true)
            dispatch(setSelectId(0))
          }}
        />

        <Modal
          width={500}
          title='确认操作'
          confirmLoading={loading}
          destroyOnClose
          visible={sureVisible}
          onCancel={() => setSureVisible(false)}
          onOk={() => {
            setLoading(true)
            const params = {
              id: detail?.id,
              stockPrice: form.getFieldValue('stockPrice'),
              retailPrice: form.getFieldValue('retailPrice'),
              flag: isChecked ? 1 : 0,
            }
            dispatch(getSyncInventoryAsync(params))
              .then(unwrapResult)
              .then((v: any) => {
                notification.success({
                  message: v,
                })
              })
              .finally(() => {
                setLoading(false)
                setSureVisible(false)
              })
          }}
        >
          <div style={{ paddingLeft: '10px' }}>
            <div style={{ display: 'flex' }}>
              <ExclamationCircleFilled
                style={{
                  color: '#FFAE55',
                  fontSize: 18,
                }}
              />
              <div style={{ margin: '-4px 0 0 10px' }}>
                <div>
                  是否给该商品的所有库存价格调整为：售价
                  {form.getFieldValue('retailPrice')}元
                </div>
                <div>如需生成变动记录，请在左下角勾选上生成变动记录</div>
              </div>
            </div>
            <Checkbox
              checked={isChecked}
              onChange={() => {
                setIsChecked(!isChecked)
                localStorage.setItem('SFSCBDJLHTJJL', JSON.stringify(!isChecked))
              }}
              style={{ margin: '10px 0', position: 'absolute', bottom: '4px' }}
            >
              生成调价记录
            </Checkbox>
          </div>
        </Modal>
      </div >
    </>
  )
}
